<template>
  <section class="ut-p-6 prospect-stage-question">
    <div class="reminder-date">
      <svg-loader :name="'icon-calendar'" :width="16" class="ut-m-0" />
      <p v-if="activteReminder">Appraisal booked for
        {{ $helpers.convertFromUTC(activteReminder.reminderDate, 'D MMM YYYY') }}</p>
    </div>
    <h3 class="question-title">Did you appraise the property?</h3>
    <div>
      <radio-button v-for="btn in answers"
              :key="btn.id"
              :id="btn.id"
              :name="'Did you appraise the property'"
              v-model="selectedAnswer"
              :selectedValue="selectedAnswer"
              :radioValue="btn.value">
              {{ btn.label }}</radio-button>
      <span class="error ut-text-sm ut-font-bold"
            v-show="validationError">
            Please select an option</span>
    </div>
    <button @click="confirm()"
            class="btn btn-green-inverted confirm-btn"
            :class="{ 'disabled': disabledButtonClick }">Confirm</button>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';
import RadioButton from '@/components/Forms/RadioButton.vue';
import ProspectStageType from '@/Mapper/ProspectStageType';

export default {
  name: 'ProspectStageQuesDidYouAppraise',
  components: {
    RadioButton,
    SvgLoader,
  },
  props: {
    prospect: {
      type: Object,
      required: true,
    },
    userid: {
      required: true,
    },
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
      selectedAnswer: null,
      validationError: false,
      answers: [
        {
          id: 'did-you-appraise-yes',
          value: 'yes',
          label: 'Yes',
        },
        {
          id: 'did-you-appraise-no-remove-prospect',
          value: 'no',
          label: 'No, remove this prospect',
        },
      ],
      disabledButtonClick: false,
    };
  },
  computed: {
    ...mapGetters('prospectStore', [
      'activteReminder',
    ]),
  },
  created() {},
  methods: {
    ...mapActions('prospectStore', [
      'createStage',
      'updateReminder',
    ]),
    confirm() {
      if (this.disabledButtonClick) {
        return false;
      }

      if (!this.selectedAnswer) {
        this.validationError = true;
        return false;
      }

      this.disabledButtonClick = true;

      if (this.selectedAnswer === 'yes') {
        // create appraised stage
        const statePayload = {
          prospectKey: this.prospect.key,
          stageTypeId: ProspectStageType.appraised,
          creatorUserId: this.userid,
        };
        this.createStage(statePayload);

        const reminderPayload = {
          id: this.activteReminder.id,
          completedDate: this.$helpers.convertToUTC(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        };

        this.updateReminder(reminderPayload).then(() => {
          this.$emit('update-view', 'appraisedCallOutcome');
        }).catch((error) => {
          this.disabledButtonClick = false;
          console.log(error);
        });
      } else if (this.selectedAnswer === 'no') {
        // Remove Prospect
        this.$emit('update-view', 'removeProspect');
      }

      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/styles/prospect-stage-questions";
</style>
